<template>
    <!-- Form Fields -->
    <div class="flex flex-col md:flex-row gap-4">
        <!-- Issuing Bank -->
        <div class="w-full md:w-1/2">
            <UiInput
                id="issuing_bank"
                name="issuing_bank"
                label="Issuing Bank"
                :error="errors?.issuing_bank || ''"
                :options="{ hideLabel: true }"
            >
                <template #input>
                    <span
                        class="block w-full mb-2 text-sm text-left font-medium text-slate-700 dark:text-slate-300"
                    >
                        Issuing Bank
                    </span>
                    <input
                        type="text"
                        class="w-full px-3 py-2 border rounded bg-white dark:bg-slate-800 text-slate-800 dark:text-slate-100 placeholder:text-slate-400 dark:placeholder:text-slate-500 focus:outline-none focus:ring-2 focus:ring-slate-400 disabled:cursor-not-allowed disabled:bg-slate-100 dark:disabled:bg-slate-700"
                        :class="errors?.issuing_bank ? 'border-red-500 focus:border-red-500' : 'border-slate-300 dark:border-slate-600 focus:border-slate-400 dark:focus:border-slate-500'"
                        v-model="modelValue.issuing_bank"
                        placeholder="e.g. American Express"
                        @input="$emit('clear-error', 'issuing_bank')"
                        :disabled="disabled"
                    />
                </template>
            </UiInput>
        </div>

        <!-- Credit Card Name -->
        <div class="w-full md:w-1/2">
            <UiInput
                id="card_not_found_name"
                name="card_not_found_name"
                label="Credit Card Name"
                :error="errors?.card_not_found_name || ''"
                :options="{ hideLabel: true }"
            >
                <template #input>
                    <span
                        class="block w-full mb-2 text-sm text-left font-medium text-slate-700 dark:text-slate-300"
                    >
                        Credit Card Name
                    </span>
                    <input
                        type="text"
                        class="w-full px-3 py-2 border rounded bg-white dark:bg-slate-800 text-slate-800 dark:text-slate-100 placeholder:text-slate-400 dark:placeholder:text-slate-500 focus:outline-none focus:ring-2 focus:ring-slate-400 disabled:cursor-not-allowed disabled:bg-slate-100 dark:disabled:bg-slate-700"
                        :class="errors?.card_not_found_name ? 'border-red-500 focus:border-red-500' : 'border-slate-300 dark:border-slate-600 focus:border-slate-400 dark:focus:border-slate-500'"
                        v-model="modelValue.card_not_found_name"
                        placeholder="e.g. Chase Freedom Unlimited®"
                        @input="$emit('clear-error', 'card_not_found_name')"
                        :disabled="disabled"
                    />
                </template>
            </UiInput>
        </div>
    </div>
    
    <!-- Helper Text -->
    <div class="mt-4 text-sm text-slate-600 dark:text-slate-300">
        <p>
            Please enter the official credit card name (e.g., Chase Freedom Unlimited®). 
            <strong>Do not enter your personal name or card number.</strong>
        </p>
    </div>
</template>
<script setup>
import UiInput from '@/components/ui/inputs/ui-input.vue';
const missingCardDetails = defineModel('modelValue', {
    type: Object,
    default: () => ({ issuing_bank: '', card_not_found_name: '' }),
});
const props = defineProps({
    errors: {
        type: Object,
        default: () => ({}),
    },
    disabled: {
        type: Boolean,
        default: false,
    },
});

const emit = defineEmits(['clear-error']);
</script>
